import React from "react";
import { createPortal } from "react-dom";
import { Box, Button, Heading, Text } from "grommet";
import { FormClose } from "grommet-icons";
import { useTranslation } from "react-i18next";
import ConversationWithAI from "./ConversationWithAI";

import "./AssistantPanel.scss";

export default function AssistantPanel({
  open,
  overModal,
  portalTarget,
  portalOffset,
  onClose,
  onNavigate,
}) {
  const { t } = useTranslation();

  const panel = (
    <aside
      className={`assistant-panel${open ? " assistant-panel--open" : ""}${
        overModal ? " assistant-panel--modal" : ""
      }`}
      aria-hidden={!open}
      style={
        overModal
          ? {
              "--assistant-modal-container-left": `${portalOffset.left}px`,
              "--assistant-modal-container-top": `${portalOffset.top}px`,
            }
          : undefined
      }
    >
      <Box
        className="assistant-panel__header"
        direction="row"
        align="center"
        justify="between"
      >
        <Box gap="none">
          <Heading level="3" margin="none">
            {t("aiAssistant.title")}
          </Heading>
          <Text size="xsmall" color="dark-5">
            {t("aiConversation.panelSubtitle")}
          </Text>
        </Box>
        <Button
          plain
          icon={<FormClose />}
          title={t("aiConversation.closePanel")}
          onClick={onClose}
        />
      </Box>
      <ConversationWithAI panel onNavigate={onNavigate} />
    </aside>
  );

  if (open && overModal && portalTarget) {
    return createPortal(panel, portalTarget);
  }

  return panel;
}
